'use strict';

/** PubSub Object Literal. */
const pubsub = {
    /**
     * Actions store for all events and callbacks
     */
    actions: [],

    /**
     * Store a callback in an event
     * @param {string} e - A custom event name
     * @param {callback} cb - A callback function
     */
    on(e, cb) {
        if(typeof this.actions[e] === 'undefined') {
            this.actions[e] = [cb];
        } else {
            this.actions[e].push(cb);
        }
        return this.actions;
    },

    /**
     * Remove a callback from an event
     * @param {string} e - A custom event name
     * @param {callback} [cb] - An optional callback function
     */
    off(e, cb) {
        if(this.actions[e]) {
            if (!cb) {
                delete this.actions[e];
            } else {
                this.actions[e].forEach((fn, i) => {
                    if(fn === cb) {
                        this.actions[e].splice(i, 1);
                    }
                });
            }
        }
    },

    /**
     * Trigger an event
     * @param {string} e - A custom event name
     * @param {Object} [d] - Optional data packet
     */
    trigger(e, d) {
        const data = d || {};
        if (this.actions[e]) {
            this.actions[e].forEach(cb => cb(data));
        }
    },
};

export default pubsub;


// WEBPACK FOOTER //
// ./resources/assets/js/pubsub.js